const luxTabs = document.querySelectorAll("[data-toggle='lux-tabs']");

luxTabs.forEach(function (tab) {
    const navWrapper = tab.closest(".lux-tabs-nav");
    const contentWrapper = tab
        .closest(".lux-tabs-wrapper")
        .querySelector(".lux-tabs-content-wrapper");

    const tabTargetId = tab.getAttribute("data-target");
    const tabTarget = contentWrapper.querySelector("#" + tabTargetId);

    tab.addEventListener("click", function (e) {
        e.preventDefault();

        if (tabTarget) {
            navWrapper.querySelectorAll(".lux-tab").forEach(function (sibling) {
                sibling.classList.remove("active");
                sibling.setAttribute("aria-selected", "false");
            });

            contentWrapper
                .querySelectorAll(".lux-tabs-content")
                .forEach(function (content) {
                    content.classList.remove("active");
                    content.setAttribute("hidden", "true");
                });

            tab.classList.add("active");
            tab.setAttribute("aria-selected", "true");
            tabTarget.classList.add("active");
            tabTarget.removeAttribute("hidden");

            window.dispatchEvent(new Event("scroll")); //trigger lazyLoad of any images that was hidden.
        }
    });
});
